import { StaticDataFetcherItem } from '@hh.ru/magritte-common-data-provider';
import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export interface VacancyBrandedTemplate extends StaticDataFetcherItem {
    active: boolean;
    id: number;
    text: string;
}

export default autoGeneratedReducer<VacancyBrandedTemplate[]>([]);
